import InventoryItem from "../../../classes/InventoryItem";
import { db } from "../../../boot/firebase";
import { collection, doc, deleteDoc, setDoc } from "firebase/firestore";

export const GET_INVENTORY_ITEM = ({ dispatch }, id) => {
  return dispatch("GET_DOC", {
    converter: InventoryItem,
    path: InventoryItem.getPath(id),
    stateKey: "inventoryItems",
    id,
  });
};

export const GET_INVENTORY_ITEMS = (
  { dispatch },
  { conditions, limitCount, pagination }
) => {
  return dispatch("GET_COLLECTION", {
    converter: InventoryItem,
    stateKey: "inventoryItems",
    path: InventoryItem.getPath(),
    conditions,
    limitCount,
    pagination,
  });
};

export const LISTEN_INVENTORY_ITEM = async (
  { dispatch },
  { id, next, error, unlisten }
) => {
  return dispatch("LISTEN_DOC", {
    converter: InventoryItem,
    path: InventoryItem.getPath(id),
    stateKey: "inventoryItems",
    id,
    next,
    error,
    unlisten,
  });
};

// `filter`: "archive" for archived items, "all" for both (the Inventory
// page's Search spans Holding and Archive), anything else for live items.
export const LISTEN_INVENTORY_ITEMS = (
  { dispatch },
  { filter, next, error, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: InventoryItem,
    path: InventoryItem.getPath(),
    stateKey: "inventoryItems",
    conditions:
      filter === "all" ? undefined : ["archived", "==", filter === "archive"],
    next,
    error,
    unlisten,
  });
};

export const SAVE_INVENTORY_ITEM = async ({ dispatch, state }, item) => {
  let path;

  const saveImages = async (existingData) => {
    return dispatch("SAVE_IMAGES", {
      parentData: item.data,
      fieldPath: "images",
      folderPath: `${path}/images`,
      existingData,
    });
  };

  if (!item.id) {
    // New Item
    item.data.created = new Date();
    item.data.createdBy = state.user.id;
    const ref = doc(collection(db, InventoryItem.getPath()));
    item.id = ref.id;
    path = item.path;

    // Upload new images
    await saveImages();

    await setDoc(doc(db, path).withConverter(InventoryItem), item);
    return item;
  } else {
    // Existing Item
    item.data.modified = new Date();
    item.data.modifiedBy = state.user.id;
    const existingData = await dispatch("GET_INVENTORY_ITEM", item.id);
    path = item.path;

    // Upload new images and delete removed images
    await saveImages(existingData.data);

    // Update
    await setDoc(doc(db, path).withConverter(InventoryItem), item);
    return item;
  }
};

export const UPDATE_INVENTORY_ITEM = ({ state }, { id, changes }) => {
  changes = { ...changes, modified: new Date(), modifiedBy: state.user.id };
  return setDoc(doc(db, InventoryItem.getPath(id)), changes, { merge: true });
};

export const RELOCATE_INVENTORY_ITEM = ({ state }, { id, locations }) => {
  return setDoc(
    doc(db, InventoryItem.getPath(id)),
    {
      modified: new Date(),
      modifiedBy: state.user.id,
      itemLocations: {
        [new Date().getTime()]: locations.filter((l) => l.quantity > 0),
      },
    },
    { merge: true }
  );
};

export const DELETE_INVENTORY_ITEM = async ({ commit }, id) => {
  await deleteDoc(doc(db, InventoryItem.getPath(id)));
  commit("REMOVE", { stateKey: "inventoryItems", id });
};
